import { ChartInfoKind } from '@frontend/chart/types';
import { Spinner } from '@frontend/components/common';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { ChartCardTitle } from '../chart-card-info/chart-card-title.component';

export interface StatisticsCardProps {
    title: React.ReactNode;
    subtitle?: React.ReactNode;
    chartKey?: string;
    infoKind?: ChartInfoKind;
    isLoading?: boolean;
    hasData?: boolean;
    compact?: boolean;
    className?: string;
    children: React.ReactNode;
    navigateUrl?: string;
}

export const StatisticsCard = (props: StatisticsCardProps) => {
    const navigate = useNavigate();
    const { title, subtitle, chartKey, infoKind, isLoading, hasData = true, compact = false, className = '', children, navigateUrl } = props;

    const cardClassName = `bg-background-surface outline-border-default flex h-full min-h-0 min-w-0 w-full flex-col items-start justify-start overflow-hidden rounded-lg outline-1 -outline-offset-1 ${
        compact ? 'gap-2 p-3' : 'gap-4 p-4'
    } ${navigateUrl ? 'cursor-pointer hover:brightness-95' : ''} ${className}`;
    const titleClassName = `text-foreground-default justify-start font-semibold ${compact ? 'text-lg' : 'text-2xl'}`;
    const subtitleClassName = `text-brand-muted justify-start ${compact ? 'text-sm font-medium' : 'text-xl font-semibold'}`;

    const titleElement = (
        <ChartCardTitle
            title={title}
            subtitle={subtitle}
            chartKey={chartKey}
            infoKind={infoKind}
            compact={compact}
            titleClassName={titleClassName}
            subtitleClassName={subtitleClassName}
        />
    );

    if (isLoading) {
        return (
            <div className={cardClassName}>
                <div className='flex shrink-0 flex-col items-start justify-start gap-1'>{titleElement}</div>
                <Spinner />
            </div>
        );
    }

    return (
        <div
            onClick={() => navigateUrl && navigate(navigateUrl)}
            className={cardClassName}>
            <div className={`flex shrink-0 flex-col items-start justify-start ${compact ? 'gap-1' : 'gap-2'}`}>{titleElement}</div>
            {!hasData ? (
                <div className='text-foreground-muted flex min-h-0 w-full min-w-0 flex-1 items-center justify-center'>
                    <FormattedMessage
                        id='table.no-data'
                        description='The label we display when there are no results in a table'
                        defaultMessage='No data to display'
                    />
                </div>
            ) : (
                <div className='flex min-h-0 w-full min-w-0 flex-1 flex-col'>{children}</div>
            )}
        </div>
    );
};
